// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedView_root__273Qz"};